import {h, Component} from 'preact';
import {withRouter} from 'react-router-dom';

import Icon from '@components/common/Icon';
import {toTitleCase} from '@util/StringUtils';

class ProgressBar extends Component {

    render ( props ) {
        return (
            <div className="registrationProgressContainer">
                <ul className="progressBar">
                    <li className={`progressBar-item text-near-black ${props.step ===
                    '1' &&
                    'active'} ${props.completed[0] === 1 && 'done'}`}>
                        <span
                            data-tooltip={props.step === '1' || props.isSubmitted ?
                                null :
                                `Go to ${toTitleCase( props.labels[0] )}`}
                            onClick={props.step === '1' || props.isSubmitted ? null : () => props.history.push( '/' )}
                            className="progressBar-item-circle text-lg md:text-2xl">
                            {props.completed[0] === 1
                                ? <Icon.ui className="text-base md:text-lg" color="white" name={'checkmark'}/>
                                : '1'
                            }
                        </span>
                        <p className="progressStep-label">{props.labels[0]}</p>
                    </li>
                    <li className={`progressBar-item text-near-black ${props.step ===
                    '2' &&
                    'active'} ${props.completed[1] === 1 && 'done'}`}>
                        <span
                            data-tooltip={props.step === '2' || props.isSubmitted ?
                                null :
                                `Go to ${toTitleCase( props.labels[1] )}`}
                            onClick={props.step === '2' || props.isSubmitted ? null : () => props.history.goBack()}
                            className="progressBar-item-circle text-lg md:text-2xl">
                            {props.completed[1] === 1
                                ? <Icon.ui className="text-base md:text-lg" color="white" name={'checkmark'}/>
                                : '2'
                            }
                        </span>
                        <p className="progressStep-label">{props.labels[1]}</p>
                    </li>
                    <li className={`progressBar-item text-near-black ${props.step ===
                    '3' &&
                    'active'} ${props.completed[2] === 1 && 'done'}`}>
                        <span
                            data-tooltip={props.step === '3' || props.isSubmitted ?
                                null :
                                `Go to ${toTitleCase( props.labels[2] )}`}
                            onClick={props.step === '3' || props.isSubmitted ? null : () => props.history.goForward()}
                            className="progressBar-item-circle text-lg md:text-2xl">
                            {props.completed[2] === 1
                                ? <Icon.ui className="text-base md:text-lg" color="white" name={'checkmark'}/>
                                : '3'
                            }
                        </span>
                        <p className="progressStep-label">{props.labels[2]}</p>
                    </li>
                </ul>
            </div>
        )
    }
}

export default withRouter( ProgressBar );